const PENDING_KEY = 'aidivecoach_onboarding_pending';

/** Marks the just-registered user as needing the welcome flow. Only registration calls this, so existing accounts are never interrupted. */
export const markOnboardingPending = (userId: string): void => {
  try { localStorage.setItem(PENDING_KEY, userId); } catch { /* storage unavailable — skip onboarding */ }
};

export const isOnboardingPending = (userId: string): boolean => {
  try { return localStorage.getItem(PENDING_KEY) === userId; } catch { return false; }
};

const RELAUNCH_EVENT = 'aidivecoach:relaunch-onboarding';

/** Asks the mounted OnboardingGate to open the welcome flow again — used by the "Welcome tour" button in Settings. */
export const requestOnboarding = (): void => {
  window.dispatchEvent(new Event(RELAUNCH_EVENT));
};

export const onOnboardingRequested = (handler: () => void): (() => void) => {
  window.addEventListener(RELAUNCH_EVENT, handler);
  return () => window.removeEventListener(RELAUNCH_EVENT, handler);
};

export const clearOnboardingPending = (): void => {
  try { localStorage.removeItem(PENDING_KEY); } catch { /* ignore */ }
};
